<script>

import { Circle3 } from "svelte-loading-spinners";
import { onMount } from "svelte";

export let currentRoute;
let company_domain = 'fiscalia'
let showForm = false

onMount(async () => {

});

const fetchData = async () => {

    const request = await fetch(`${__myapp.env.API_URL}client/${company_domain}/content?type=terms`);
    const json = await request.json();

    showForm = true

    return {
        content: json.data.content.content,
    }

};

const request = fetchData();

</script>

<section id="about" class="section">
    <div class="container px-lg-4 px-xl-5">
        <div class="row">
            <div class="col-12 mx-auto">

                {#await request}

                    <div class="d-flex justify-content-center">
                    <Circle3
                        size="60"
                        ballTopLeft="#4843d2"
                        ballTopRight="#4843d2"
                        ballBottomLeft="#4843d2"
                        ballBottomRight="#4843d2"
                        unit="px" />
                    </div>

                {:then result}

                    {#if showForm}

                        <div class="col-lg-10 mx-auto" style="max-height: 100vh; overflow: auto; font-size: 13pt;">

                            {@html result.content}

                        </div>

                    {/if}

                {:catch error}

                    <div class="alert alert-danger" style="border-radius:0px" role="alert">

                        <h1>Error</h1>
                        <p style="font-size: 18pt;">No hemos podido obtener la información, contacta al administrador.</p>

                    </div>

                {/await}

            </div>
        </div>

    </div>
</section>